import { trackCustomEvent } from '../../lib/metaPixel';

const trainingEventNames = new Set([
  'catalog_view',
  'offer_card_click',
  'landing_view',
  'pricing_view',
  'module_open',
  'mode_select',
  'whatsapp_cta_click',
  'faq_open',
  'testimonial_view',
]);

export function trackTrainingEvent(name, dimensions = {}) {
  if (!trainingEventNames.has(name)) return;

  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, dimensions);
    }
  } catch {
    // Third-party tracking must never interrupt the visitor journey.
  }

  try {
    trackCustomEvent(name, { customData: dimensions });
  } catch {
    // Keep adapters isolated if the Meta helper is replaced or extended later.
  }
}

export function observeTrainingSection(element, callback) {
  if (!element || typeof IntersectionObserver === 'undefined') return undefined;

  let fired = false;
  let observer;

  observer = new IntersectionObserver((entries) => {
    if (fired || !entries.some(({ isIntersecting }) => isIntersecting)) return;

    fired = true;
    observer.disconnect();

    try {
      callback();
    } catch {
      // Observation callbacks must not destabilize the page.
    }
  });
  observer.observe(element);

  return observer;
}
